import { Injectable } from '@angular/core';
import {TypologyLabel} from '@modules/activities/core/typologies/typology.label';
import {ModelSchema, Structures} from "octopus-model";
import {SwitchSettingsType} from 'shared/utils/settings';
import {modulesSettings} from '../../../../settings';
import {get} from "lodash-es";

const RawSettings = {
    activitiesOptions: Structures.object({}),
    activitiesWithDefinedTypology: Structures.array([]),
};

const settingsStructure: ModelSchema = new ModelSchema(RawSettings);

@Injectable({
  providedIn: 'root'
})
export class ActivitiesConfigurationService {

    private readonly privateSettings: Partial<SwitchSettingsType<typeof RawSettings> & {
        activityOptions: { displayAnswersLabel: boolean } | undefined,
        activitiesWithDefinedTypology: TypologyLabel[]
    }>;

    constructor() {
        this.privateSettings = settingsStructure.filterModel(modulesSettings.activities);
    }

    public activityOptions(typology: 'trueFalse' | 'qcu'): { displayAnswersLabel: boolean } | undefined {
        const activityOptions = get(this.privateSettings, 'activitiesOptions', {});
        return activityOptions[typology] || undefined;
    }

    public activitiesWithDefinedTypology(): TypologyLabel[] {
        return get(this.privateSettings, 'activitiesWithDefinedTypology', []);
    }
}
